export const getFileType = (filename: string): string => {
  const ext = filename.toLowerCase().split('.').pop();
  const mimeTypes: Record<string, string> = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    jfif: 'image/jfif',
    webp: 'image/webp',
    pdf: 'application/pdf',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  };

  return mimeTypes[ext || ''] || 'application/octet-stream';
};

export const isImageFile = (fileType: string): boolean => {
  return fileType.startsWith('image/');
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const validateFileSize = (file: File, maxSizeInMB: number): boolean => {
  const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
  return file.size <= maxSizeInBytes;
};

export const getFileSizeInMB = (bytes: number): number => {
  return bytes / (1024 * 1024);
};

/**
 * Truncates a filename to a maximum length while preserving the file extension
 * @param filename - The original filename
 * @param maxLength - Maximum length for the filename (default: 10)
 * @returns Truncated filename with ellipsis if needed
 */
export const truncateFilename = (
  filename: string,
  maxLength: number = 10
): string => {
  // Remove spaces from filename
  const cleanFilename = filename.replace(/\s+/g, '');
  const lastDotIndex = cleanFilename.lastIndexOf('.');

  // If no extension found, treat entire string as name
  if (lastDotIndex === -1) {
    if (cleanFilename.length > maxLength) {
      return `${cleanFilename.substring(
        0,
        maxLength - 5
      )}...${cleanFilename.slice(-2)}`;
    }
    return cleanFilename;
  }

  const name = cleanFilename.substring(0, lastDotIndex);
  const extension = cleanFilename.substring(lastDotIndex);

  if (name.length > maxLength) {
    return `${name.substring(0, maxLength - 5)}...${name.slice(
      -2
    )}${extension}`;
  }

  return cleanFilename;
};
